import { Controller } from "stimulus";
import {getState, setState} from '../search_results/state'


export default class extends Controller {

  filterChanged() {
    let currentUrl = window.location.href
    let url = new URL(currentUrl);
    // If the listing ID is in the URL, remove it (and anything after it) before we fill in the list view
    let pattern = /\/search_results\/\d{26}.*/
    url.pathname = url.pathname.replace(pattern, '/search_results')
    url.pathname = url.pathname.replace('search_results','stats_view')
    showFullContent(url.toString() + '&_filter=' + getState('filter'));
  }
}